import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Select, Button, Table, Modal, Input, DatePicker, Switch, message, Cascader } from 'antd';
import "./index.less";
import { queryAuditList } from "../../api";
const { Option } = Select;

const searchKeyNumList = [
    {
        id: 3,
        name: '全部',
    },
    {
        id: 0,
        name: '高频',
    },
    {
        id: 1,
        name: '中频',
    },
    {
        id: 2,
        name: '低频',
    }

]
const dabiaoList = [
    {
        id: 3,
        name: '全部',
    },
    {
        id: 0,
        name: '是',
    },
    {
        id: 1,
        name: '否',
    },
]


// 父组件 最外层
function ClassifyManage() {

    const [classifyName, setClassifyName] = useState('');//分类名称填写
    const [searchKeyNumValue, setSearchKeyNumValue] = useState(3);// 频次value
    const [isDabiaoValue, setIsDabiaoValue] = useState(3);// 是否达标
    const [listLoading, setListLoading] = useState(false)
    const [tableList, setTableList] = useState([]);
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(9)
    const [total, setTotal] = useState(0)
    let history = useHistory()
    useEffect(() => {
        getDataList(1, false)
    }, [])

    const columns = [
        // {
        //     title: "序号",
        //     render: (text, record, index) => `${index + 1}`,
        //     width: '8%'
        // },
        {
            title: '分类名称',
            dataIndex: 'classifyName',
            width: '8%',
        },
        {
            title: '分类搜索频次',
            width: '8%',
            render: (r, q) => {
                return (
                    <span>
                        {r.level == 0 ? '高频' : (r.level == 1 ? '中频' : '低频')}
                    </span>
                )
            }
        },
        {
            title: '分类ID',
            dataIndex: 'classifyId',
            width: '8%',
        },
        {
            title: '已审核数量',
            dataIndex: 'isAuditNum',
            width: '8%',
        },
        {
            title: '案例总数量',
            dataIndex: 'totalCaseNum',
            width: '8%',
        },
        {
            title: '已审核占比',
            dataIndex: 'proportion',
            width: '8%'
        },
        {
            title: '是否达标',
            width: '12%',
            render: (r, q) => {
                return (
                    <span>
                        {r.isStandard == 0 ? '是' : '否'}
                    </span>
                )
            }
        },
        {
            title: '操作',
            dataIndex: '',
            width: '12%',
            render: (v, r) => {
                return (
                    <Button onClick={() => clickShenhe(r)} type={r.isStandard == 0 ? 'primary' : 'danger'} style={{ 'margin-left': '10px' }}>审核</Button>
                )
            },
        }
    ]
    //  下架当前案例
    const clickShenhe = (record) => {
        history.push('/case/quickShenheDetail/' + record.classifyId)
    }
    // 获取案例列表 渲染表格
    const getDataList = (page, resetBol) => {
        setListLoading(true)
        let params = {
            classifyName: classifyName,
            isStandard: isDabiaoValue == 3 ? null : isDabiaoValue,
            level: searchKeyNumValue == 3 ? null : searchKeyNumValue,
            page: page,
            pageSize: pageSize,

        }
        if (resetBol) {
            params.classifyName = '';
            params.isStandard = null;
            params.level = null;
        }

        queryAuditList(params).then((res) => {
            if (res?.error?.errorCode == 0) {
                if (res?.data?.contents.length > 0) {
                    setTableList(res?.data?.contents)
                    setTotal(res?.data?.total)
                } else {
                    setTableList([])
                    setTotal(0)
                    message.error('暂无数据')
                }
            }
        }).finally(() => {
            setListLoading(false)
        })
    }

    //  分类搜索词频次  
    const handleChangeStyle = value => {
        setSearchKeyNumValue(value)
    }
    //  分类搜索词频次  
    const isDabiao = value => {
        setIsDabiaoValue(value)
    }
    // 查询
    const searchList = () => {
        setPage(1)
        getDataList(1, false)
    }
    // 重置选项
    const resetData = () => {
        setIsDabiaoValue(3)
        setSearchKeyNumValue(3)
        setClassifyName('')
        setPage(1)
        getDataList(1, true)
    }

    return (
        <div className="classifyManage">
            <div className="topForm">
                <h2>
                    分类审核
                </h2>

                <div className="myForm">
                    <div>
                        <span className="select_label">分类名称：</span>
                        <Input style={{ width: 155 }} placeholder="请输入分类名称" value={classifyName} onChange={(e) => {
                            setClassifyName(e.target.value)
                        }} />
                    </div>
                    <div>
                        <span className="select_label">分类搜索频次：</span>
                        <Select value={searchKeyNumValue} style={{ width: 120 }} onChange={handleChangeStyle}>
                            {
                                searchKeyNumList.length > 0 ? searchKeyNumList.map((item, index) => {
                                    return (
                                        <Option value={item.id} key={index}>{item.name}</Option>
                                    )
                                }) : ''
                            }
                        </Select>
                    </div>
                    <div>
                        <span className="select_label">是否达标</span>
                        <Select value={isDabiaoValue} style={{ width: 120, marginLeft: '10px' }} onChange={isDabiao}>
                            {
                                dabiaoList.length > 0 ? dabiaoList.map((item, index) => {
                                    return (
                                        <Option value={item.id} key={index}>{item.name}</Option>
                                    )
                                }) : ''
                            }
                        </Select>
                    </div>
                    <div>
                        {/* <Button type="primary" onClick={search}>查询</Button> */}
                        <Button type="primary" onClick={searchList}>查询</Button>
                        <Button type="primary" onClick={resetData}>重置</Button>
                    </div>
                </div>

            </div>
            <div className="bottomTable">
                <Table
                    loading={listLoading}
                    columns={columns}
                    dataSource={tableList}
                    pagination={
                        {
                            total: total,
                            current: page,
                            onChange(page) {
                                setPage(page)
                                getDataList(page, false)
                            },
                            pageSize: pageSize
                        }
                    }
                />
            </div>
        </div >
    )
}

export default ClassifyManage;